import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import React, { forwardRef, memo } from 'react';
import ListingSectionItem from './ListingSectionItem';

/**
 * ListingSection component.
 * @param {object} props - Component props.
 * @param {number} props.spacing - Grid spacing.
 * @param {React.Node} props.children - Children components.
 * @param {object} props.rest - Rest of the props.
 * @param {object} ref - React ref.
 * @returns {React.JSX.Element} Rendered component.
 */

const ListingSectionComponent = forwardRef(({ children, spacing = null, ...rest }, ref) => {
  // check if childrens are from type ListingSectionItem
  const childrens = React.Children.toArray(children);
  const hasValidChildren = childrens.every((child) => child.type === ListingSectionItem);
  if (!hasValidChildren) {
    throw new Error('ListingSection must have ListingSectionItem as children');
  }

  return (
    <Container ref={ref} {...rest} maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
      <Grid container spacing={spacing || 2}>
        {children}
      </Grid>
    </Container>
  );
});

ListingSectionComponent.displayName = 'ListingSection';

const ListingSection = memo(ListingSectionComponent);

export default ListingSection;
